import { api, useApi, FetcherOptions } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import { responseInterface, ConfigInterface } from 'swr';
import { Product } from '@gik/core/models/gik/Product';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';

const PATH = 'products';

export default async function getProducts(productIds: number[], per_page?: number): Promise<Product[]> {
  const apiResponse: ResponsePromise = api(PATH, {
    method: 'GET',
    searchParams: { include: productIds.join(','), per_page },
  });
  return await apiResponse.json<Product[]>();
}

// TODO: is the `Data = Product[]` generics necessary here?
export function useProducts<Data = Product[], Error = WordpressError>(
  productIds?: number[],
  config?: ConfigInterface,
  options?: FetcherOptions,
  per_page?: number
): responseInterface<Data, Error> {
  return useApi<Data, Error>(productIds?.length > 0 ? PATH : null, config, {
    searchParams: {
      include: productIds && productIds.join(','),
      per_page,
    },
    ...options,
  });
}

export async function getSuggestedProducts(situationIds: number[]): Promise<Product[]> {
  const apiResponse: ResponsePromise = api(PATH, {
    method: 'GET',
    searchParams: {
      suggestBySituationIds: situationIds?.join(','),
      per_page: 4,
    },
  });
  return await apiResponse.json<Product[]>();
}

// TODO: is the `Data = Product[]` generics necessary here?
export function useSuggestedProducts<Data = Product[], Error = WordpressError>(
  situationIds: number[],
  config?: ConfigInterface,
  options?: FetcherOptions
): responseInterface<Data, Error> {
  return useApi<Data, Error>(situationIds?.length ? PATH : null, config, {
    searchParams: {
      suggestBySituationIds: situationIds?.join(','),
      per_page: 4,
    },
    ...options,
  });
}

export interface emailRecipientInfoPayload {
  userId?: string; // for logged in users
  userEmail?: string; // for guests only, either this or userId must be provided
  subscribeToNewsletter?: boolean;
  inkindRouteId: string;
}

export async function emailRecipientInfo(productId: number, payload: emailRecipientInfoPayload) {
  const apiResponse: ResponsePromise = api.post(`${PATH}/${productId}/emailRecipientInfo`, {
    json: payload,
  });
  return await apiResponse.json();
}
